import { apiDownloadUrl, apiGet } from './api';

export type TrackingResponse = { success: boolean; data?: any; message?: string };

export const trackingApi = {
  getDocumentsOverTime: async (userId: string, startDate?: string, endDate?: string): Promise<TrackingResponse> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const qs = params.toString();
    return apiGet(`/api/v1/tracking/user/${userId}/analytics/documents-over-time${qs ? `?${qs}` : ''}`);
  },
  getTimeSpentPerDocument: async (
    userId: string,
    startDate?: string,
    endDate?: string,
    limit: number = 20
  ): Promise<TrackingResponse> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    params.append('limit', String(limit));
    return apiGet(`/api/v1/tracking/user/${userId}/analytics/time-spent-per-document?${params.toString()}`);
  },
  getActivityTimeline: async (
    userId: string,
    startDate?: string,
    endDate?: string,
    groupBy: string = 'day'
  ): Promise<TrackingResponse> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    params.append('groupBy', groupBy);
    return apiGet(`/api/v1/tracking/user/${userId}/analytics/activity-timeline?${params.toString()}`);
  },
  getDocumentTypeEngagement: async (userId: string, startDate?: string, endDate?: string): Promise<TrackingResponse> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const qs = params.toString();
    return apiGet(`/api/v1/tracking/user/${userId}/analytics/document-type-engagement${qs ? `?${qs}` : ''}`);
  },
  getNavigationPaths: async (
    userId: string,
    startDate?: string,
    endDate?: string,
    limit: number = 30
  ): Promise<TrackingResponse> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    params.append('limit', String(limit));
    return apiGet(`/api/v1/tracking/user/${userId}/analytics/navigation-paths?${params.toString()}`);
  },
  exportCsvUrl: (userId: string, startDate?: string, endDate?: string, format = 'sessions') => {
    const params = new URLSearchParams({ format });
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    return apiDownloadUrl(`/api/v1/tracking/user/${userId}/export/csv?${params.toString()}`);
  },
  exportJsonUrl: (userId: string, startDate?: string, endDate?: string, format = 'sessions') => {
    const params = new URLSearchParams({ format });
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    return apiDownloadUrl(`/api/v1/tracking/user/${userId}/export/json?${params.toString()}`);
  },
};

